/**
 * Created by heweiguang on 2019-07-25.
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FullScreen from './FullScreen';

const root = document.body;

/**
 * 直接插在 body 下，处理和 ant design picker 的层级冲突
 */
class PortalFullScreen extends Component {
  constructor(props) {
    super(props);

    this.el = document.createElement('div');
    this.el.style.position = 'relative';
    this.el.style.zIndex = '1000';
  }

  componentDidMount() {
    root.appendChild(this.el);
  }

  componentWillUnmount() {
    root.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(<FullScreen {...this.props} />, this.el);
  }
}

export default PortalFullScreen;
